import { render, staticRenderFns } from "./pcGrowup2.vue?vue&type=template&id=05740cbf&scoped=true&"
import script from "./pcGrowup2.vue?vue&type=script&lang=js&"
export * from "./pcGrowup2.vue?vue&type=script&lang=js&"
import style0 from "./pcGrowup2.vue?vue&type=style&index=0&id=05740cbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05740cbf",
  null
  
)

export default component.exports